import gql from 'graphql-tag';

const getCardAddressImportUrlQuery = gql`
  query getCardAddressImportUrl($account_card_id: RecordID!) {
    me {
      id
      email_address
      web_app_urls {
        card_address_import_url(account_card_id: $account_card_id)
      }
    }
  }
`;

export default getCardAddressImportUrlQuery;
